export default __webpack_public_path__ + "static/media/home-main.148908ce.png";